import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil } from '@fortawesome/pro-light-svg-icons'

import { Box, Link } from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'

interface ActionsProps {
  campaignId: number,
}

const Actions = (props: ActionsProps) => {
  const { campaignId } = props

  const {
    callbacks: {
      manageCampaignValidations,
    },
  } = useCampaign({ id: campaignId })

  return (
    <Box justifyContent="center" alignItems="center">
      <Link
        greyLink
        onClick={() => manageCampaignValidations()}
        textProps={{ fontSize: 'medium', height: 'fit-content' }}
      >
        <FontAwesomeIcon icon={faPencil} />
      </Link>
    </Box>
  )
}

export default Actions
